import React, { forwardRef, useMemo } from 'react';
import { Divider } from '@chakra-ui/react';
import classnames from 'classnames';
import { Button, ButtonGroup } from '@/components/common/Button';
import { useCurrentUser } from '@/core/hooks/useCurrentUser';
import { isNewLinesInstituteOrgId } from '@/utils/isNewLinesOrgId';
import { TimeFilterPresets } from '../../TimeFilterControl.const';
import { useTimeFilterPresetsTitles } from '../../hooks/useTimeFilterPresetsTitles';
import styles from './TimeControlPanel.module.scss';

interface Props {
  activePreset?: TimeFilterPresets | null;
  onPresetChange: (preset: TimeFilterPresets) => void;
}

export const TimeControlPanel = forwardRef<HTMLDivElement, Props>(({ activePreset, onPresetChange }, ref) => {
  const { orgId } = useCurrentUser();
  const presets = useTimeFilterPresetsTitles();
  const presetButtons = useMemo(
    () =>
      presets
        .filter((item) => !(isNewLinesInstituteOrgId(orgId) && item.value === TimeFilterPresets.FUTURE))
        .map(({ value, title }, index, items) => {
          return (
            <React.Fragment key={value}>
              <Button
                size="md"
                className={classnames(styles.button, { [styles.isActive]: value === activePreset })}
                onClick={() => onPresetChange(value)}
              >
                {title}
              </Button>
              {index < items.length - 1 && <Divider className={styles.divider} orientation="vertical" />}
            </React.Fragment>
          );
        }),
    [activePreset, orgId],
  );

  return (
    <div className={styles.root} ref={ref}>
      <ButtonGroup spacing={0} className={styles.buttonsGroup}>
        {presetButtons}
      </ButtonGroup>
    </div>
  );
});

export default TimeControlPanel;
